<template>
  <div>
    <section class="mainPart">
      <el-form :model="verifyForm" inline class="membForm" @submit.native.prevent>
        <el-form-item>
          <el-input v-model.trim="verifyForm.membercode"  ref="refcode4" placeholder="请输入或扫描会员ID" clearable @keyup.enter.native="submit">
            <i slot="prefix" class="iconsm pfIco"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query()" :loading="loading1">查询</el-button>
        </el-form-item>
      </el-form>
      <!--S 会员基本信息-->
      <div v-show="memberInfo" class="memberArea widthAuto">
        <dl class="flexUI singleWrap">
          <dt>
            <a class="tuWrap"><img class="imgCenter"
                :src="memberInfo.hpurl ? memberInfo.hpurl : 'https://presale.jhtsoft.com/picms/c47519dc61feb.png'"
                :onerror="this.src='https://presale.jhtsoft.com/picms/c47519dc61feb.png'"></a>
            <span>{{memberInfo.mlevelname}}</span>
          </dt>
          <dd>
            <h3 class="flexUpDownCenter" :title="memberInfo.nickname">
              <span class="textFl">{{memberInfo.realname || memberInfo.username || memberInfo.nickname}}</span><i
                v-if="memberInfo.sex != 2"
                :class="[{'iconfemale':memberInfo.sex == 1},{'iconmale':memberInfo.sex == 0}]"></i>
            </h3>
            <p>会员ID：{{memberInfo.memberid}}</p>
            <p>手机号码：{{memberInfo.mphone||'--'}}</p>
          </dd>
          <dd>
            <p>注册时间：{{dateTime(memberInfo.regdate, 1)}} </p>
            <p>注册方式：{{memberInfo.regway == 0 ? '微信自动注册' : memberInfo.regway == 1 ? '自定义账号注册' : '企业内部注册'}}</p>
          </dd>
        </dl>
        <ul class="flexGoodsWrap">
          <li>会员资产</li>
          <li>
            <em class="blueColor">{{memberInfo.cardnum||0}}</em>
            <b>兑换礼券</b>
          </li>
          <li>
            <em class="orangeColor">{{memberInfo.couponnum||0}}</em>
            <b>优惠券</b>
          </li>
          <li class="flexUpDownCenter">
            <span>
              <em class="redColor">{{memberInfo.rbalance | formatAmount}}</em>
              <b>商城币</b>
            </span>
            <el-button type="primary" size="small" @click="spendCoins">消费商城币</el-button>
          </li>
        </ul>
      </div>
      <div v-show="!memberInfo&&showinfo" class="memberArea errorBox widthAuto">
        <i class="el-icon-s-custom"></i>
        <div>
          <p>未查到会员信息</p>
          <span>请输入或扫描会员ID查询</span>
        </div>
      </div>
      <!--E 会员基本信息--->
      <!--S 资产明细-->
      <el-tabs v-model="activeBalanceTav" v-show="memberInfo" ref="memberHead" class="ruleTab" type="card">
        <em class="searchTip"
          v-if="activeBalanceTav=='cardGiftsTab' || activeBalanceTav=='couponsTab'">检索{{activeBalanceTav=='cardGiftsTab'?'兑换礼券':'优惠券'}}：<el-checkbox
            v-model="expired" @change="expiredclick">即将过期</el-checkbox></em>
        <el-tab-pane name="cardGiftsTab">
          <span slot="label">
            <b class="textFl">兑换礼券</b>
            <em v-show="activeBalanceTav=='cardGiftsTab'">
              <i class="greyColor">（</i>
              <b class="commonNum">{{cardGiftData.length||0}}</b>
              <i class="greyColor">张可用）</i>
            </em>
          </span>
          <el-table ref="cvTable" class="comTable cardVertifyTab" border v-loading="cardloading" :data="cardGiftData" :maxHeight="tableHeight"
            :key="'cardGiftsTab'" :row-class-name="tableRowClassName">
            <el-table-column label="序号" type="index" width="60" fixed></el-table-column>
            <el-table-column label="券卡信息" fixed min-width="330">
              <template slot-scope="scope">
                <section class="flexUI cardbagWrap">
                  <span class="tuWrap" :class="{'qkAvatar':!(scope.row.setkindpic ||scope.row.kindpic || scope.row.maingoodspic)}">
                    <img v-if="scope.row.setkindpic ||scope.row.kindpic || scope.row.maingoodspic" :src="scope.row.setkindpic?scope.row.setkindpic:scope.row.kindpic?scope.row.kindpic:scope.row.maingoodspic" alt=""
                      onerror="this.src='http://presale.jhtsoft.com/picms/1c87b2d7fece10.jpg'" class="imgAlign">
                    <i class="iconqk" v-else></i>
                  </span>
                  <div>
                    <p class="noWrap">{{scope.row.code}}<em v-show="scope.row.serial">【{{scope.row.serial}}】</em></p>
                    <p class="textFl">
                      <template v-if="scope.row.setgoodsname||scope.row.setkindinfo">
                       {{scope.row.setgoodsname}}&nbsp;&nbsp;{{scope.row.setkindinfo }}
                      </template>
                      <template v-else>
                       {{scope.row.defaultgoodsname}}
                      </template>
                    </p>
                    <p class="priceFont redColor"><i>￥</i>{{scope.row.cardprice|formatAmount}}
                      <el-tag type="danger" plain v-if="scope.row.cardcategory===0">定量组合提货卡</el-tag>
                      <el-tag type="warning" plain v-if="scope.row.cardcategory===1">套餐组合提货卡</el-tag>
                      <el-tag type="success" plain v-if="scope.row.cardcategory===2">定额组合提货卡</el-tag>
                    </p>
                  </div>
                </section>
              </template>
            </el-table-column>
            <el-table-column label="券卡规则" min-width="250">
              <template slot-scope="scope">
                <div v-if="String(scope.row.cardcategory)>=0">
                  <p v-if="scope.row.cardcategory!==2">
                    <em>可兑换商品总数：</em>
                    <span>{{scope.row.goodspicknum||'--'}}</span>
                  </p>
                  <p v-if="scope.row.cardcategory===0&&scope.row.remiangoodspicknum!='undefiend'">
                    <em>剩余可兑换商品数：</em>
                    <span>{{scope.row.remiangoodspicknum}}</span>
                  </p>
                  <p  v-if="scope.row.cardcategory===0||scope.row.cardcategory===1">
                    <em>单次提货最少兑换商品数：</em>
                    <span>{{scope.row.minpicknumonce}}</span>
                  </p>
                  <p  v-if="scope.row.cardcategory===2">
                    <em>券卡额度：</em>
                    <span>{{scope.row.cardprice | formatAmount}}</span>
                  </p>
                  <p v-if="String(scope.row.cardcategory)>=0">
                    <em >最多可提货次数：</em>
                    <span> {{scope.row.usenum}}</span>
                  </p>
                  <p v-else >
                    <em class="greyColor">可使用次数：</em>
                    <span> {{scope.row.usenum}}</span>
                  </p>
                </div>
                <span v-if="scope.row.cardcategory!==0&&scope.row.cardcategory!==1&&scope.row.cardcategory!==2">
                  <!--一个专区10选择2-->
                  <template
                    v-if="scope.row.selzones==1&&scope.row.optgoodsList&&scope.row.optgoodsList.length==1">
                    支持{{testlistnum(scope.row.optgoodsList,scope.row.defaultgoodscode)}}选
                    {{testzoneselnum(scope.row.optgoodsList)}}
                  </template>
                  <!--大于一个专区 共可选择10件-->
                  <template v-else-if="scope.row.selzones>1">
                    共可选择{{scope.row.selnum}}件商品
                  </template>
                  <!--一个默认商品-->
                  <template  v-else>1选1</template>
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="ElementControls('Quota_Pickupcard')==1? '剩余次数/额度':'剩余次数'" min-width="180">
              <template slot-scope="scope">
                <p><small v-if="scope.row.cardcategory===2" class="greyColor">剩余提货次数：</small>{{scope.row.residuenum}}</p>
                 <p v-if="scope.row.cardcategory===2"><small class="greyColor">券卡剩余额度：</small>{{scope.row.remainamount|formatAmount}}</p>
                <small class="orangeColor" v-if="scope.row.state == 0 || scope.row.state == 1">{{scope.row.state | cardStateFilter}}</small>
                <small class="greenColor" v-else-if="scope.row.state == 2 || scope.row.state == 5 || scope.row.state == 7">{{scope.row.state | cardStateFilter}}</small>
                <small class="redColor" v-else-if="scope.row.state == 4 || scope.row.state == 6">{{scope.row.state | cardStateFilter}}</small>
                <small class="blueColor" v-else-if="scope.row.state == 3">{{scope.row.state | cardStateFilter}}</small>
                <small class="greyColor" v-else>{{scope.row.state | cardStateFilter}}</small>
              </template>
            </el-table-column>
            <el-table-column label="有效期" min-width="220">
              <template slot-scope="scope">
                <p v-if="scope.row.startvaldate && scope.row.endvaldate">{{dateTime(scope.row.startvaldate)}} ~
                  {{dateTime(scope.row.endvaldate)}}</p>
                <p v-if="scope.row.startvaldate && !scope.row.endvaldate">{{dateTime(scope.row.startvaldate)}}后有效</p>
                <p v-if="!scope.row.startvaldate && scope.row.endvaldate">{{dateTime(scope.row.endvaldate)}}前有效</p>
                <p v-if="!scope.row.startvaldate && !scope.row.endvaldate">长期有效</p>
                <el-tag v-if="scope.row.expired == 1" type="warning" plain>即将过期</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="可兑换商城币" min-width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.shopcurrencynum||'--'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="90">
              <template slot-scope="scope">
                <p class="handle">
                  <a v-if="scope.row.cardstatus == 0&&scope.row.cardcategory!==0&&scope.row.cardcategory!==1&&scope.row.cardcategory!==2&&scope.row.pickupFlag ==1" class="iconkfth" title="立即提货"
                    @click="getShowChoseGoods(scope.row)"></a>
                  <a v-if="scope.row.supportshopcurrency == 1&&scope.row.state==1" class="iconcoins" title="转商城币"
                    @click="shangchengbi(scope.row)"></a>
                </p>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
          </el-table>
          <section class="flexBet summaryBot">
            <div class="total flexUpDownCenter">
              <b class="iconbulb"></b>注：定量组合提货卡、套餐组合提货卡、定额组合提货卡仅支持消费者自助提货；粉色背景的兑换礼券表示不支持到当前门店提货，请消费者自行查阅卡包，前往券卡指定门店提货
            </div>
            <!-- <Page></Page> -->
          </section>
        </el-tab-pane>
        <el-tab-pane name="couponsTab">
          <span slot="label">
            <b class="textFl">优惠券</b>
            <em v-show="activeBalanceTav=='couponsTab'">
              <i class="greyColor">（</i>
              <b class="commonNum">{{pageTotal||0}}</b>
              <i class="greyColor">张可用)</i>
            </em>
          </span>
          <el-table ref="cvTable" class="comTable cardVertifyTab" border :data="couponData" v-loading="vloading"
            :maxHeight="tableHeight" :key="'couponsTab'">
            <el-table-column label="序号" type="index" width="60"></el-table-column>
            <el-table-column label="优惠券信息" min-width="200">
              <template slot-scope="scope">
                <section class="flexUI cardbagWrap">
                  <span class="tuWrap darkRed"><i class="iconyhq3"></i></span>
                  <div>
                    <h4>{{`全场满${scope.row.minconamount}元立减${scope.row.facevalue}`}}</h4>
                    <p>券码：{{scope.row.code}}</p>
                  </div>
                </section>
              </template>
            </el-table-column>
            <el-table-column label="可抵扣金额（￥）" min-width="150">
              <template slot-scope="scope">
                <span>{{scope.row.facevalue}}</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期" min-width="180">
              <template slot-scope="scope">
                <p v-if="scope.row.startvaldate && scope.row.endvaldate">{{dateTime(scope.row.startvaldate)}} ~
                  {{dateTime(scope.row.endvaldate)}}</p>
                <p v-if="scope.row.startvaldate && !scope.row.endvaldate">{{dateTime(scope.row.startvaldate)}}后有效</p>
                <p v-if="!scope.row.startvaldate && scope.row.endvaldate">{{dateTime(scope.row.endvaldate)}}前有效</p>
                <p v-if="!scope.row.startvaldate && !scope.row.endvaldate">长期有效</p>
                <el-tag v-if="scope.row.expired == 1" type="warning" plain>即将过期</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="90">
              <template slot-scope="scope">
                <p class="handle">
                  <a class="iconhx" title="立即核销" @click="useCoupon(scope.row)"></a>
                </p>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
          </el-table>
          <!-- S 分页 -->
          <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam">
          </Page>
          <!-- E 分页 -->
        </el-tab-pane>
        <el-tab-pane label="商城币" name="mallCoinsTab">
          <p class="pb20">
            <el-button v-for="(item,index) in timeLimit" :key="index" type="warning"
              :plain="index === currentDate?false:true" size="small" @click="clickywerty(index)">{{item}}</el-button>
            <el-button type="primary" size="small" @click="spendCoins">消费商城币</el-button>
          </p>
          <!--E 检索-->
          <el-table ref="cvTable" :data="balanceData" class="orderTable comTable" border v-loading="vloading"
            :maxHeight="tableHeight" :key="'mallCoinsTab'">
            <el-table-column type="index" label="序号" fixed></el-table-column>
            <el-table-column label="渠道来源" min-width="150">
              <template slot-scope="scope">
                <span>{{scope.row.source | sourceFlters}}</span>
              </template>
            </el-table-column>
            <el-table-column label="数量" min-width="150">
              <template slot-scope="scope">
                <h3 :class="scope.row.type==0?'greenColor':'redColor'">{{scope.row.type==0?'+':'-'}}{{scope.row.amount}}
                </h3>
              </template>
            </el-table-column>
            <el-table-column label="操作时间" min-width="180">
              <template slot-scope="scope">
                <span>{{dateTime(scope.row.upddate,1)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作备注" min-width="200">
              <template slot-scope="scope">
                <span>{{scope.row.memo || '--'}}</span>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
          </el-table>
          <!-- S 分页 -->
          <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam1">
          </Page>
          <!-- E 分页 -->
        </el-tab-pane>
      </el-tabs>
      <!--E 资产明细-->
    </section>

    <!-- S 提货选择可选商品 -->
    <GoodsChoose v-if="goodsChoseDialogVisible" :delmode="0" :goodsChoseDialogVisible="goodsChoseDialogVisible"
      :lookOrEditType="lookOrEdit" :code="currentCode" :initUseTimes="currentUseTimes"
      :initSelectGoods="currentCodeInfo.goodsMap" :enAbleEdite="currentEnAbleEdite" @closeChild="getCloseGoodsCld"
      :memberSource="memberSource" :codelistinfo="codelistinfo" v-on:selectSubmit="goodsSelectSubmit"></GoodsChoose>
    <!-- E 提货选择可选商品 -->
    <!--S 1选1提货直接订单备注-->
    <el-dialog :visible.sync="orderMemoShow" title="提货" class="comDlog lowerMdg" append-to-body
      :close-on-click-modal="false">
      <el-form :model="getGoodsForm">
        <el-form-item label="本次提货消耗次数">
          <el-input-number v-model="getGoodsForm.consumptetimes" size="small" :min="1" :max="codelistinfo.residuenum"
            :step="1" v-on:change="consumpteTimesChange()"
            step-strictly></el-input-number>&nbsp;&nbsp;，剩余<em>{{codelistinfo.residuenum
            -getGoodsForm.consumptetimes}}</em>次可提
        </el-form-item>
        <el-form-item>请填写订单备注，备注不得超过<em>100</em>字</el-form-item>
        <el-form-item>
          <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" maxlength="100" show-word-limit
            placeholder="填写备注" v-model="getGoodsForm.memo"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeOdMemo(1)">确定</el-button>
        <el-button @click="closeOdMemo(0)">取消</el-button>
      </div>
    </el-dialog>
    <!--E 1选1提货直接订单备注订单备注-->

    <!--S 提交成功提示框-->
    <el-dialog class="comDlog deliverySuccessDlg" title="提示" :visible.sync="submitDeliveryBox" append-to-body
      :close-on-click-modal="false">
      <section class="successOdTip flexUI">
        <i class="el-icon-success"></i>
        <div>
          <h2 class="comAlert">提货成功！</h2>
          <p>生成订单号：<b id="bar1">{{orderlist.orderno}}</b><em class="blueColor autoCopy" data-clipboard-action="copy"
              data-clipboard-target="#bar1" @click="handleCopy">复制</em></p>
        </div>
      </section>
      <h3 class="shopTit flexBet">商品清单
        <!-- <em>剩余提货次数：<i class="redColor fwBold">2</i></em> -->
      </h3>
      <el-table class="comTable" border :data="cardRelatedGoods" :maxHeight="400">
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="商品内容" min-width="280">
          <template slot-scope="scope">
            <div class="giftInfo flexUpDownCenter">
              <span><img :src="scope.row | imageShow"
                  onerror="this.scr='https://presale.jhtsoft.com/picms/c47499b67d489.png'" class="imgAlign"></span>
              <p>
                <span class="txtLineTwo"
                  :title="scope.row.goodsname+' '+scope.row.kindinfo">{{scope.row.goodsname}}  {{scope.row.kindinfo}}</span>
                <b class="priceFont redColor"><i>¥</i>&nbsp;{{scope.row.goodsprice|formatAmount}}</b>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="提货数量" min-width="120">
          <template slot-scope="scope"><em class="commonNum">{{scope.row.goodsnum}}</em></template>
        </el-table-column>
        <template slot="empty">
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDeliveryBox = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- E 提交成功提示框 -->

    <!--S 转商城币弹窗-->
    <el-dialog class="comDlog alertMsgDlog" title="系统提示" :visible.sync="transferCoinsShow" append-to-body
      :close-on-click-modal="false">
      <div class="alertBox">
        <i class="el-icon-warning"></i>
        <h2 class="comAlert">确定将该券卡转换成商城币？</h2>
        <p>当前券卡可转：<em class="redColor fwBold">{{rowliat.shopcurrencynum}}</em>&nbsp;商城币</p>
        <small>该操作不可逆，请谨慎操作~</small>
      </div>
      <p class="msgBtns">
        <el-button type="primary" size="small" @click="closeTransfer(1)">确定</el-button>
        <el-button plain size="small" @click="closeTransfer(0)">取消</el-button>
      </p>
    </el-dialog>
    <!-- E 转商城币弹窗 -->

    <!--S 优惠券核销弹窗-->
    <el-dialog class="comDlog wideDlg" title="优惠券核销" :visible.sync="couponWriteOffShow" append-to-body
      :close-on-click-modal="false">
      <couponWriteOff :couponWriteOffShow="couponWriteOffShow" :memberSource="1" :membercode="this.yhmembercode" @closeCoupon="closeCouponBox"></couponWriteOff>
    </el-dialog>
    <!--S 优惠券核销弹窗-->

    <!--S 商城币消费弹窗-->
    <el-dialog class="comDlog narrowDlg" title="消费商城币" :visible.sync="spendCoinsShow" append-to-body
      :close-on-click-modal="false">
      <el-form :model="reduceForm" class="commonForm" label-width="140px" ref="ruleForm" :rules="reduceRules">
        <el-form-item label="商城币余额">
          <span class="redColor fontPrice fwBold">{{memberInfo.rbalance | formatAmount}}</span>
        </el-form-item>
        <el-form-item label="本次消费数量" prop="spendnum">
          <el-input v-model="reduceForm.spendnum" maxlength="6" @input="allamounts" clearable
            placeholder="请输入本次消费商城币数量"></el-input>
        </el-form-item>
        <el-form-item label="消费备注">
          <el-input v-model="reduceForm.memo" type="textarea" :autosize="{ minRows: 5, maxRows: 10}" maxlength="100"
            show-word-limit placeholder="请填写消费备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeCoinsBox(1)">确定</el-button>
        <el-button @click="closeCoinsBox(0)">取消</el-button>
      </div>
    </el-dialog>
    <!--S 商城币消费弹窗-->

  </div>
</template>
<script>
  import Clipboard from "clipboard";
  import { Message, MessageBox } from "element-ui";
  import Api from "@/apis/api"
  export default {
    name: 'MembersVisit',
    data() {
      return {
        memberSource:1,
        cardloading:false,
        showinfo:false,
        datestat:'',
        cardRelatedGoods: [], // 商品汇总数据
        cardGoodsCode: [], // 已选商品的code集合
        orderlist: '',
        codelistinfo: '',
        firstTimes: false,
        currentCodeInfo: null,
        currentCode: "",
        currentUseTimes: 1,
        currentEnAbleEdite: true,
        lookOrEdit: false, //查看or更改商品
        rowliat: '',
        yhmembercode: '',
        pageTotal: 0, //总数
        currentPage: 1, // 页数
        pageSize: 30, // 条数
        loading1: false,
        vloading: false,
        verifyForm: {
          membercode: '', //会员编号
        },
        memberInfo: '',//会员信息
        activeBalanceTav: 'cardGiftsTab',//当前选中tab
        expired: false,//检索即将过期的礼券和优惠券
        cardGiftData: [], //兑换礼券数据            
        goodsChoseDialogVisible: false, //选择可选商品弹框
        transferCoinsShow: false,//转商城币弹窗
        submitDeliveryBox: false,//提货成功弹窗
        choseGoodsData: [
        ],
        orderMemoShow: false,//1选1则直接填写订单备注
        getGoodsForm: {
          consumptetimes: 1,//提货消耗次数
          restimes: 19,
          memo: ''
        },
        couponData: [],
        couponWriteOffShow: false,//优惠券核销弹窗

        timeLimit: ['近三个月内', '三个月以前'],//检索时限
        currentDate: '',//当前检索时间
        balanceData: [],//商城币明细
        spendCoinsShow: false,//消费商城币弹窗
        reduceForm: {
          spendnum: '',
          memo: ''
        },
        reduceRules: {
          spendnum: [
            { required: true, message: '消费数量不能为空！' },
          ],
        },
        tableHeight: window.innerHeight * .8, //表格动态高度 
      }
    },
    filters: {
      imageShow: function (row) {
        return row.kindpic
          ? row.kindpic
          : row.maingoodspic
            ? row.maingoodspic
            : "https://presale.jhtsoft.com/picms/c47499b67d489.png";
      },
      //渠道来源
      sourceFlters(val) {
        if (val == 0) {
          return '券卡提货'
        } else if (val == 1) {
          return '商城购买'
        } else if (val == 2) {
          return '商品溯源'
        } else if (val == 3) {
          return '营销活动'
        } else if (val == 4) {
          return '分享返利'
        } else if (val == 5) {
          return '消费卡充值'
        } else if (val == 6) {
          return '会员签到'
        } else if (val == 7) {
          return '积分兑换'
        } else if (val == 8) {
          return '订单取消'
        } else if (val == 9) {
          return '商品评价'
        } else if (val == 10) {
          return '新人礼包'
        } else if (val == 11) {
          return '余额提现'
        } else if (val == 12) {
          return '商家后台操作'
        } else if (val == 13) {
          return '线下购买'
        } else if (val == 14) {
          return '兑换商城币'
        }
      }
    },
    components: {
      GoodsChoose: resolve => require(["@/components/OrderFolder/GoodsChoose.vue"], resolve), //选择可选商品
      couponWriteOff: resolve => require(["@/views/OrderFolder/Coupon.vue"], resolve), //优惠券核销
      Page: resolve => require(["@/components/common/Page.vue"], resolve),
    },
    watch: {
      //监听切换
      activeBalanceTav(val) {
        this.pageTotal = 0 //总数
        this.currentPage = 1 // 页数
        this.pageSize = 30 // 条数
        this.expired = false
        this.currentDate=''
        if (val == 'cardGiftsTab') {
          this.getCardList()
        } else if (val == 'couponsTab') {
          this.getCouponList();
        } else {
          this.getRecord()
        }
        this.getHeight()
      }
    },
    // ============================================== 方法 ==============================================
    methods: {
      expiredclick(){
        if (this.activeBalanceTav == 'cardGiftsTab') {
          this.getCardList()
        } else if (this.activeBalanceTav == 'couponsTab') {
          this.getCouponList();
        } 
      },
      consumpteTimesChange() {
        Api.SETCARDUSENUM({ code: this.codelistinfo.code, usenum: this.getGoodsForm.consumptetimes }).then(res => {
          let status = res.data.status;
        });
      },
      allamounts(val) {
        if (val == '00'||val == '0') {
          this.reduceForm.spendnum = '';
        } else {
          this.reduceForm.spendnum = this.amountChech(val);
        }
      },
      nowPageParam(val, vals) {
        this.pageSize = val;
        this.currentPage = vals;
        // this.$refs.gsTable.bodyWrapper.scrollTop = 0;
        this.getCouponList();
      },
      nowPageParam1(val, vals) {
        this.pageSize = val;
        this.currentPage = vals;
        // this.$refs.gsTable.bodyWrapper.scrollTop = 0;
        this.getRecord()
      },
      getCouponList() {
        let param = {
          membercode: this.memberInfo.membercode,
          expired: this.expired ? 1 : '',
          pageparam: {
            pagesize: this.pageSize, //每页条数
            currentpage: this.currentPage, //当前页数
          }
        }
        this.vloading = true;
        Api.GETCOUPONLIST(param).then(res => {
          // this.toTableTop('gsTable');
          if (res.data.status == "200") {
            this.vloading = false;
            this.couponData = res.data.data;
            this.pageTotal = res.data.pagebean.totalnum;
          } else {
            this.vloading = false;
            this.pageTotal = 0;
            this.couponData = [];
          }
        })
      },
      clickywerty(index){
        console.log(index)
        if(index===this.currentDate){
          this.currentDate=''
        }else{
          this.currentDate = index
        }
        this.getRecord()
      },
      getRecord() {
        let param = {
          membercode: this.memberInfo.membercode,
          startdate: this.currentDate===0?this.datestat:'',
          enddate:this.currentDate===1?this.datestat:'',
          pageparam: {
            pagesize: this.pageSize, //每页条数
            currentpage: this.currentPage, //当前页数
          }
        }
        this.vloading = true;
        Api.GETRECORDLIST(param).then(res => {
          // this.toTableTop('gsTable');
          if (res.data.status == "200") {
            this.vloading = false;
            this.balanceData = res.data.data;
            this.pageTotal = res.data.pagebean.totalnum;
          } else {
            this.vloading = false;
            this.pageTotal = 0;
            this.balanceData = [];
          }
        })
      },
      getCardList() {
        if(!this.memberInfo.membercode){
          return
        }
        this.cardloading = true
        let param = {
          membercode: this.memberInfo.membercode,
          expired: this.expired ? 1 : '',
        }
        Api.GETCARDLIST(param).then(res => {
          if (res.data.status == "200") {
            this.cardGiftData = res.data.data
            this.cardloading = false
          } else {
            this.cardGiftData = []
            this.cardloading = false
          }
        }).catch((err)=>{
          this.cardloading = false
        })
      },
      query() {
        if (!this.verifyForm.membercode) {
          return
        }
        this.activeBalanceTav = 'cardGiftsTab'
        this.getMemberInfo()
        setTimeout(() => {
          this.getCardList()
        }, 500)
      },
      submit() {
        this.query()
      },
      //获取会员信息
      getMemberInfo() {
        this.loading1 = true
        Api.GETMEMBERINFO({ membercode: this.verifyForm.membercode ? this.verifyForm.membercode : this.memberInfo.membercode }).then(res => {
          if (res.data.status == "200") {
            this.memberInfo = res.data.data;
            this.loading1 = false
            this.showinfo = false
          } else {
            this.memberInfo = ''
            this.loading1 = false
            this.showinfo = true
            this.memberInfo = ''
          }
        }).catch((err) => {
          this.loading1 = false
          this.showinfo = true
          this.memberInfo = ''
        })
        //在dom渲染之后
        setTimeout(() => {
          this.getHeight();
        }, 300)
      },
      // 不支持到当前门店提货的table的背景色
      tableRowClassName({ row, rowIndex }) {
        if (row.pickupFlag == 0) {
          return 'redBg';
        }
        return '';
      },
      notForceGoodsOutDateLimitMessage(isgoodsoutdate) {
        let pubordprintinfo = this.config.getPubordprintinfo();
        let forceDeliveryDate = pubordprintinfo.forcedeliverydate;
        if (forceDeliveryDate === 0 && isgoodsoutdate) {
          MessageBox.confirm("警示！默认商品不在销售日期内，提货需按照企业当前的发货政策进行！", '系统提示', {
            confirmButtonText: '关闭',
            showCancelButton: false,
            type: 'warning'
          }).then(() => { }).catch(() => { })
        }
      },
      notForceCardLimitMessage(iscardoutdate, isgoodsoutdate, codeinfo) {
        let pubordprintinfo = this.config.getPubordprintinfo();
        let forceDeliveryDate = pubordprintinfo.forcedeliverydate;
        if (forceDeliveryDate === 0 && iscardoutdate) {
          MessageBox.confirm("警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！", '系统提示', {
            confirmButtonText: '关闭',
            showCancelButton: false,
            type: 'warning'
          }).then(() => { }).catch(() => { })
        }
      },
      // 打开选择可选商品弹窗
      getShowChoseGoods(val) {
        Api.INITIALIZE({ delimode: 0 }).then(res => {
          if (res.data.status == "200") {
            let param = {
              code: val.code,
              pickway: 0,
              isfromcardbag: 1
            }
            Api.VALIDATE(param).then(res => {
              if (res.data.status !== "200") {
                Message.error({ message: res.data.message });
                return;
              }
              let data = res.data.data;
              let codeinfo = data.codeinfo;
              let validateInfo = {
                code: codeinfo.code,
                serial: codeinfo.serial,
                sellChannel: codeinfo.channelname,
                printMemo: codeinfo.printmemo,
                memo: codeinfo.sermemo,
                cardoutmemo: data.memo,
                consumpteTimes: 1, // 默认1
                residuenum: codeinfo.residuenum,
                canChangeGoods: true,
                goods: [],
                goodsMap:{}
              };
              this.memberSource = codeinfo.residuenum
              this.codelistinfo = validateInfo
              this.currentEnAbleEdite = true;
              let needChooseGoods = true;
              if (data.resulttype === 0) {
                // 有默认商品，且默认商品状态可选，自动选择默认商品
                let resultinfo = data.resultinfo;
               
                if (resultinfo.defaultSetStatus === "000") {
                  // 默认商品设置成功
                  validateInfo.canChangeGoods = resultinfo.selgoods.length > 1;
                  this.currentEnAbleEdite = resultinfo.selgoods.length > 1;
                  validateInfo.goods = [resultinfo.selgoods[0]];
                  validateInfo.goodsMap = { singleList: [resultinfo.selgoods[0]] };
                  this.currentCodeInfo = validateInfo;
                  needChooseGoods = false;
                  this.notForceGoodsOutDateLimitMessage(resultinfo.isoutgooddate);
                } else if (resultinfo.defaultSetStatus === "001") {
                  // 只有默认商品设置失败
                  MessageBox.confirm("券卡绑定商品不可用，默认商品不可用！", '系统提示', {
                    confirmButtonText: '关闭',
                    showCancelButton: false,
                    type: 'warning'
                  }).then(() => { }).catch(() => { })
                  // Message.warning({
                  //   message: "券卡绑定商品不可用，默认商品不可用！"
                  // });
                  return;
                } else {
                  // 有默认有可选，默认商品设置失败
                  validateInfo.canChangeGoods = true;
                  this.currentEnAbleEdite = true;
                  needChooseGoods = true;
                  this.currentCodeInfo = validateInfo;
                }
                this.currentCodeInfo = validateInfo;
                this.currentCode = codeinfo.code;
                if (data.optgoodsinfos) {
                  this.goodsChoseDialogVisible = true;
                } else {
                  this.getGoodsForm.consumptetimes = 1
                  this.getGoodsForm.memo = ''
                  this.orderMemoShow = true;
                }
              }
              if (needChooseGoods) {
                // 没有默认商品，弹出商品选择
                if (data.resultinfo.isoutcarddate === 1) {
                  MessageBox.confirm("警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！", '系统提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'warning'
                  }).then(() => {
                    this.currentCode = codeinfo.code;
                    this.currentUseTimes = validateInfo.consumpteTimes;
                    this.currentCodeInfo = validateInfo;
                    this.firstTimes = true;
                    this.goodsChoseDialogVisible = true;
                  }).catch(() => { })
                } else {
                  this.currentCode = codeinfo.code;
                  this.currentUseTimes = validateInfo.consumpteTimes;
                  this.currentCodeInfo = validateInfo;
                  this.firstTimes = true;
                  this.goodsChoseDialogVisible = true;
                }
              } else {
                this.notForceCardLimitMessage(data.resultinfo.isoutcarddate, data.resultinfo.isoutgooddate, codeinfo);
              }
            }).catch(res => {
            });
          }
        })

      },
      // 关闭选择可选商品弹窗
      getCloseGoodsCld(val) {
        this.goodsChoseDialogVisible = false;
      },
      goodsSelectSubmit($event, memo) {
        console.log("selectedGoodsDatas", $event, memo);
        let param = { code: $event.code, usenum: $event.useTimes };
        let goodsInfo = $event.goodsinfo;
        let goodsInfos = [];
        let goodsMap = {};
        if ($event.type === 0) {
          // 有默认商品
          if ($event.selectDefaultGoods === 1) {
            param.isSelectDef = 1;
            param.defaultgoodscode = goodsInfo["singleList"][0].kindcode;
          } else {
            param.isSelectDef = 0;
            param.kindcodes = {};
            param.kindcodes["1"] = goodsInfo["singleList"][0].kindcode;
          }
          goodsInfos.push(goodsInfo["singleList"][0]);
          goodsMap["singleList"] = goodsInfo["singleList"];
        } else {
          // 无默认商品
          param.isSelectDef = 0;
          let kindcodes = {};

          for (let key in goodsInfo) {
            let kindcodeStr = [];
            for (let item of goodsInfo[key]) {
              kindcodeStr.push(item.kindcode);
              goodsInfos.push(item);
            }
            kindcodes[key.split("@")[1]] = kindcodeStr.join("@");
            goodsMap[key.split("@")[0]] = goodsInfo[key];
          }

          param.kindcodes = kindcodes;
        }

        this.currentCodeInfo.goods = goodsInfos;
        this.currentCodeInfo.kindcodes = param.kindcodes;
        this.currentCodeInfo.goodsMap = goodsMap;

        // var hasValidateInfo = this.cardVertifyData.find(item => {
        //   if (item.code === this.currentCodeInfo.code) {
        //     return item;
        //   }
        // });

        // if (hasValidateInfo) {
        //   hasValidateInfo.goods = this.currentCodeInfo.goods;
        //   hasValidateInfo.kindcodes = this.currentCodeInfo.kindcodes;
        //   hasValidateInfo.goodsMap = this.currentCodeInfo.goodsMap;
        // } else {
        //   // this.cardVertifyData.push(this.currentCodeInfo);
        // }

        this.currentCodeInfo = null;
        Api.SETCARDGOODS(param).then(res => {
          if (res.data.status !== "200") {
            Message.error({ message: res.data.message });
            return;
          } else {
            this.goodsChoseDialogVisible = false
            if(this.memberSource>1){
              this.getGoodsForm.consumptetimes = 1
              this.getGoodsForm.memo = ''
              this.orderMemoShow = true;
            }else{
              this.getGoodsForm.memo = memo
              this.closeOdMemo(1)
            }
          }
        });
      },
      //关闭1选1弹窗
      closeOdMemo(val) {
        if (val == 1) {
          let params = {
            delimode: 0,
            ordermemo: this.getGoodsForm.memo,
            terminaltype: 0
          }
          Api.SUBMITORDER(params).then(res => {
            if (res.data.status == "200") {
              this.orderlist = res.data.data
              this.getGoodsForm.memo = ''
              this.getGoodsForm.consumptetimes=1
              this.orderMemoShow = false;
              this.submitDeliveryBox = true
              this.getMemberInfo()
              this.getCardList()
              Api.GET_ORDCARDSANDGOODSINFO({ orderno: this.orderlist.orderno }).then(res => {
                if (res.data.status === "200") {
                  let list = res.data.data;
                  this.$nextTick(() => {
                    list.forEach(item => {
                      this.getGoodsinfoByKindcodes(item);
                    });
                  });
                }
              });
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          this.getGoodsForm.memo = ''
          this.getGoodsForm.consumptetimes=1
          this.orderMemoShow = false;
        }
      },
      getGoodsinfoByKindcodes(ccard) {
        let list = ccard.actgoodscode.split("#");
        let codeList = [];
        let arr = [];
        list.forEach(code => {
          if (codeList.indexOf(code) == -1) {
            let info = {
              code: code,
              num: 1
            }
            codeList.push(code);
            arr.push(info);
          } else {
            let index = codeList.indexOf(code);
            arr[index].num += 1;
          }
        })
        this.cardRelatedGoods = [];
        this.cardGoodsCode = [];
        Api.GET_GOODSINFOBYKINDCODES({
          actgoodscode: ccard.actgoodscode.split(",").join("#")
        }).then(res => {
          if (res.data.status === "200") {
            let data = res.data.data;
            data.forEach(item => {
              let codeIndex = codeList.indexOf(item.kindcode);
              if (this.cardGoodsCode.indexOf(item.kindcode) == -1) {
                item.goodsnum = ccard.connum * arr[codeIndex].num;
                this.cardRelatedGoods.push(item);
                this.cardGoodsCode.push(item.kindcode);
              } else {
                let index = this.cardGoodsCode.indexOf(item.kindcode);
                this.cardRelatedGoods[index].goodsnum += (ccard.connum * arr[codeIndex].num);
              }
            })
          }
        });
      },
      // 复制订单编号
      handleCopy() {
        var clipboard = new Clipboard(".autoCopy");
        clipboard.on("success", e => {
          Message({
            type: 'success',
            message: '已成功复制到剪贴板!',
          });
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", e => {
          // 不支持复制
          Message({
            type: 'warning',
            message: '该浏览器不支持一键复制!'
          });
          // 释放内存
          clipboard.destroy();
        });
      },
      //优惠券核销
      useCoupon(item) {
        this.yhmembercode = item.code
        this.couponWriteOffShow = true;
      },
      //关闭优惠券核销弹窗
      closeCouponBox(val) {
        this.couponWriteOffShow = false;
        if (val == 1) {
          this.getMemberInfo()
          this.getCouponList();
        }
      },
      shangchengbi(row) {
        this.rowliat = row
        this.transferCoinsShow = true
      },
      //关闭转商城币
      closeTransfer(val) {
        if (val == 1) {
          let params = {
            code: this.rowliat.code,
            membercode: this.memberInfo.membercode
          }
          Api.TRUECOINS(params).then(res => {
            if (res.data.status == "200") {
              Message({
                message: res.data.message,
                type: 'success'
              });
              this.getMemberInfo()
              this.getCardList()
            } else {
              Message({
                message: res.data.message,
                type: 'error'
              });
            }
          })

        }
        this.transferCoinsShow = false;
      },
      //消费商城币
      spendCoins() {
        this.activeBalanceTav = 'mallCoinsTab'
        this.reduceForm.spendnum=''
        this.reduceForm.memo =''
        this.spendCoinsShow = true;
        setTimeout(()=>{
          this.$refs['ruleForm'].resetFields();
        })
      },
      //关闭消费商城币
      closeCoinsBox(val) {
        if (val == 1) {
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              let params = {
                membercode: this.memberInfo.membercode,
                coins: this.reduceForm.spendnum,
                memo: this.reduceForm.memo,
              }
              Api.USECOINS(params).then(res => {
                if (res.data.status == "200") {
                  this.$refs['ruleForm'].resetFields();
                  this.spendCoinsShow = false;
                  this.$message.success(res.data.message)
                  this.getMemberInfo()
                  this.getRecord()
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        } else {
          this.$refs['ruleForm'].resetFields();
          this.spendCoinsShow = false;
        }
      },
      //动态获取表格高度
      getHeight() {
        if (this.memberInfo) {
          let tbHeight = 0;
          if (this.activeBalanceTav == 'mallCoinsTab') {
            tbHeight = this.$refs.memberHead.$el.offsetTop + 65; //顶部检索条件占据的高度
          } else {
            tbHeight = this.$refs.memberHead.$el.offsetTop; //顶部检索条件占据的高度
          }
          this.tableHeight = window.innerHeight - tbHeight - 170;
        }
      },
      testlistnum(item, code) {
        let nums = 0
        if (code != 0) {
          nums = 1
        }
        item.map((items) => {
          nums += items.listnum
        })
        return nums
      },
      testzoneselnum(tiem) {
        let nums = 0
        tiem.map((items) => {
          nums += items.zoneselnum
        })
        return nums
      },
    },
    created() {
      //页面浏览器视窗变化绑定resize事件
      window.addEventListener("resize", this.getHeight);
    },
    mounted() {
      this.$nextTick(() => {
          this.$refs.refcode4.focus();
      });
      let d = new Date();
      d.setMonth(d.getMonth() - 3); 
      this.datestat = this.dateTime(d,1)
    },
    destroyed() {
      window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
  }
</script>
<style scoped>
  .mainPart {
    padding: 20px;
    height: calc(100% - 40px);
    overflow-y: auto;
  }

  .pfIco {
    font-size: 16px;
    color: #C0C4CC;
  }

  .membForm .el-input {
    width: 320px;
  }

  .memberArea {
    position: relative;
    padding: 10px 20px;
    display: -webkit-flex;
    display: flex;
    /* flex-wrap: wrap; */
    align-items: flex-start;
    margin-bottom: 20px;
    border: solid 1px #ebeef5;
    overflow: hidden;
    background: #fafafa;
    box-sizing: border-box;
  }

  /*会员信息 */
  .singleWrap {
    flex: 0 0 50%;
    max-width: 580px;
    padding-right: 20px;
    margin-right: 20px;
    border-right: dashed 1px #ccc;
    align-items: flex-end;
  }

  .singleWrap dt {
    position: relative;
    text-align: center;
    margin-right: 10px;
    margin-bottom: 10px;
    max-height: 72px;
  }

  .singleWrap dt .tuWrap {
    position: relative;
    display: block;
    width: 72px;
    height: 72px;
    border: solid 1px #ebeef5;
    border-radius: 37.5px;
    overflow: hidden;
  }

  .singleWrap dt span {
    position: absolute;
    z-index: 2;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    white-space: nowrap;
    min-width: 50px;
    max-width: 50px;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 3px 5px;
    line-height: 1;
    border-radius: 10px;
    background: #FFAE48;
    color: #fff;
    font-size: 12px;
  }

  .singleWrap dd {
    flex: 0 0 calc(50% - 36px);
    max-width: calc(50% - 36px);
    line-height: 23px;
  }

  .singleWrap h3 {
    font-size: 16px;
    color: #333;
  }

  .singleWrap h3 .textFl {
    display: inline-block;
    width: auto;
    max-width: calc(100% - 30px);
    padding-right: 10px;
  }

  .singleWrap h3 i {
    display: inline-block;
    vertical-align: top;
  }

  .singleWrap p {
    color: #999;
    white-space: nowrap;
  }

  .flexGoodsWrap {
    flex: 1 1 50%;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    -webkit-align-items: center;
    align-items: center;
    justify-content: space-between;
    align-items: stretch;
  }

  .flexGoodsWrap li:first-child {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
  }

  .flexGoodsWrap li:not(:first-child) {
    flex: 1 1 30%;
    padding-top: 10px;
    white-space: nowrap;
  }
  .flexGoodsWrap li:last-child {flex: 1 1 40%;}

  .flexGoodsWrap li em {
    display: block;
    font-size: 18px;
    font-weight: 600;
  }

  .flexGoodsWrap li .el-button {
    margin-left: 10px;
  }
  @media screen and (max-width: 1200px){
    .singleWrap p {font-size: 12px;}
  }
  @media screen and (min-width: 1600px) {
      .flexGoodsWrap {flex: 0 0 50%;max-width: calc(100% - 600px);}
  }
  /*错误信息占位 */
  .errorBox {
    display: flex;
    padding: 30px;
    align-items: center;
    color: #999;
    min-height: 200px;
  }

  .errorBox i {
    font-size: 60px;
    padding: 0 10px 0 20px;
  }

  .errorBox div {
    flex: 1;
    line-height: 25px;
  }

  .errorBox div p {
    font-size: 16px;
  }

  /*tab切换 */
  .ruleTab>>>.el-tabs__nav {
    height: 40px;
  }

  .ruleTab>>>.el-tabs__item {
    color: #333;
    font-weight: 700;
    min-width: 130px;
    max-width: 240px;
    text-align: center;
    height: 100%;
  }
  .ruleTab>>>.el-tabs__item>span {display:block;line-height:36px;}
  .ruleTab>>>.el-tabs__item>span>b,
  .ruleTab>>>.el-tabs__item>span>em {
    display: inline-block;
    vertical-align: top;
    font-weight:bold;
  }

  .ruleTab>>>.el-tabs__item>span>b {
    width: auto;
    max-width: 120px;
  }

  .ruleTab>>>.el-tabs__header .el-tabs__item.is-active {
    border-top: solid 3px var(--main-color);
    background: #fff;
    line-height: 36px;
  }

  .ruleTab>>>.el-tabs__header {
    margin: 0;
    margin-bottom: 10px;
  }

  .goodsNum {
    height: 50px;
    width: 100%;
    padding: 0 10px;
    margin: 10px 0;
    background: #f5f7fa;
    line-height: 50px;
    color: #333;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
  }

  .goodsNum b,
  .ruleTab>>>.el-tabs__item>span>em b {
    color: #F7615E;
    font-weight: 600;
    margin: 0 5px
  }

  .goodsNum i,
  .ruleTab>>>.el-tabs__item>span>em i {
    color: #999;
    margin: 0
  }

  .ruleTab>>>.el-tabs__item>span>em {
    color: #999;
  }

  .ruleWrap b i {
    color: #333;
    margin-left: 0;
    margin-right: 5px
  }

  .ruleWrap b .moneyIcon {
    margin-right: 0;
    font-size: 14px;
    font-weight: 400
  }

  .ruleTab>>>.el-tabs__content {
    overflow: visible;
  }

  .searchTip {
    position: absolute;
    right: 20px;
    top: -55px;
    line-height: 40px;
  }

  .handle .iconhx:before {
    font-size: 22px;
  }

  /*礼品券卡布局 */
  .comTable.el-table--border>>>.redBg {
    background: #FEF7F7;
  }

  .summaryBot {
    height: 32px;
    padding-top: 10px;
  }

  .summaryBot>>>.page {
    margin-top: 0px !important;
  }

  .total {
    margin: 0 10px;
    position: relative;
    line-height: 21px;
    color: #666;
  }

  .total span {
    margin-right: 10px;
    white-space: nowrap;
  }

  .total>b {
    font-weight: bold;
    color: #000;
    align-self: flex-start;
    white-space: nowrap;
  }

  .total p {
    flex: 1;
    margin-left: 10px;
  }

  .cardbagWrap {
    align-items: center;
  }

  .cardbagWrap>span {
    position: relative;
    width: 65px;
    min-width:65px;
    height: 65px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
    display: block;
    border: 1px solid #ebebf5;
    text-align: center;
    line-height: 65px;
    box-sizing: border-box;
  }

  .cardbagWrap>div {
    width: calc(100% - 60px);
  }

  .cardbagWrap>div h4 {
    font-weight: 600;
  }

  .qkAvatar {
    background: linear-gradient(to bottom, #9B8456, #AA966F);
  }

  .qkAvatar .iconqk {
    color: #D1B887;
  }

  .qkAvatar .iconqk:before,
  .darkRed .iconyhq3:before {
    font-size: 40px;
  }

  .darkRed {
    background: linear-gradient(270deg, #f55e30, #f60d33);
  }

  .darkRed .iconyhq3 {
    color: #fa8f77;
  }

  .pb20 {
    padding: 10px 0 20px;
  }

  /*转商城币弹窗 */
  .alertMsgDlog>>>.el-dialog {
    width: 420px;
    border-radius: 4px;
    overflow: hidden;
    padding-bottom: 20px;
  }

  .alertBox {
    position: relative;
    width: 70%;
    margin: 0 auto;
    padding: 17px 10px 17px 36px;
  }

  .alertBox .el-icon-warning {
    position: absolute;
    left: 0;
    top: 15px;
    color: #E6A23C;
    font-size: 24px;
  }

  .msgBtns {
    text-align: center;
    padding: 5px 15px 0;
  }

  .alertMsgDlog small {
    color: #999;
    font-size: 12px;
    padding: 10px 0;
  }

  /*提货成功汇总弹窗*/
  .deliverySuccessDlg>>>.el-dialog {
    width: 750px;
  }

  .successOdTip {
    width: 50%;
    margin: 20px auto;
  }

  .successOdTip .el-icon-success {
    color: #67C23A;
    font-size: 24px;
  }

  .successOdTip div {
    padding-left: 10px;
  }

  .successOdTip em {
    padding: 0 10px;
    cursor: pointer;
  }

  .successOdTip small {
    color: #999;
    font-size: 12px;
    padding: 10px 0;
  }

  .shopTit {
    font-weight: bold;
    color: #333;
    font-size: 14px !important;
    padding: 15px 0;
    border-top: dashed 1px #ccc;
  }

  .giftInfo>span {
    width: 60px;
    height: 60px;
    border: 1px solid #EBEEF5;
    position: relative;
  }

  .giftInfo p {
    margin-left: 10px;
    width: calc(100% - 70px);
  }


  /*优惠券核销弹窗 */
  .wideDlg>>>.el-dialog {
    width: 750px;
    height: 747px;
  }

  .wideDlg>>>.el-dialog__body {
    max-height: calc(100% - 70px);
  }

  /*消费商城币弹窗 */
  .narrowDlg>>>.el-dialog {
    width: 650px;
  }
</style>


// WEBPACK FOOTER //
// src/views/OrderFolder/MembersVisit.vue